const state = {
  language: localStorage.getItem('language') ? localStorage.getItem('language') : null,
  period: localStorage.getItem('period') ? JSON.parse(localStorage.getItem('period')) : null,
}

const getters = {
  language: state => state.language,
  period: state => state.period,
}

const mutations = {
  setLanguage: (state, language) => {
    state.language = language
    localStorage.setItem('language', language)
  },
  removeLanguage: state => {
    state.language = null
    localStorage.removeItem('language')
  },
  setPeriod: (state, period) => {
    state.period = period
    localStorage.setItem('period', JSON.stringify(period))
  },
  removePeriod: state => {
    state.period = null
    localStorage.removeItem('period')
  },
}

const actions = {
  setCurrentLanguage: ({ commit }, language) => {
    commit('setLanguage', language)
  },
  removeCurrentLanguage: ({ commit }) => {
    commit('removeLanguage')
  },
  setCurrentPeriod: async ({ commit }, period) => {
    await commit('setPeriod', period)
  },
  setDateRange: async ({ commit }, dateRange) => {
    const period = [dateRange.start, dateRange.end]
    await commit('setPeriod', period)
  },
  removeCurrentPeriod: async ({ commit }) => {
    await commit('removePeriod')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
